import React from 'react';

/**
 * 캠페인 통계 요약 컴포넌트
 * @param {Object} props
 * @param {Object} props.summary - 통계 데이터 객체
 * @param {Array<{key: string, label: string}>} props.fields - 표시할 필드 정의
 */
function CampaignSummary({ summary = {}, fields = [] }) {
  if (!fields || fields.length === 0) {
    return null;
  }

  return (
    <div className="summary">
      {fields.map((field) => (
        <div key={field.key} className="summary-box">
          {field.label}
          <br />
          <strong>{summary[field.key] || 0}</strong>
        </div>
      ))}
    </div>
  );
}

export default React.memo(CampaignSummary);

